import { LinkableEntityType } from '@api';
import { LegacyAnchor } from '@common';

type FestivalAnchorPropsType = { festival: LinkableEntityType };

export const FestivalAnchor: React.FC<FestivalAnchorPropsType> = ({
  festival,
}) => {
  return (
    <LegacyAnchor href={`/projects/festivals/${festival.id}`}>
      {festival.name}
    </LegacyAnchor>
  );
};
